module.exports = __webpack_public_path__ + "static/036-a447255ec9672b70462f5714a2d59140.jpg";